export const isMapsRoute = pathname => /^\/(maps|crime|tax-density-map|traffic-density)(\/|$)/.test(pathname);
